import Technology from "../catalog/Catalog";

const AccesoriesPage = () => {
  const headline = 'Accessories';
  const title = 'Accessories';

  return (
    <Technology headline={headline} title={title} />  
  );
};

export default AccesoriesPage;